import {
  cookie,
  localstorage,
  parseTranslations,
  CommonTranslations,
  Login,
  updateCartCounter
} from '@pmi/pmi-iqos-shared-react'
import { api } from '@dcx-common/services'
import LoginTranslations from './login.json'

const setTDCampaignsCookies = td_campaigns => {
  let cookieValue = null
  Object.keys(td_campaigns).forEach(name => {
    td_campaigns[name].forEach(c => {
      cookieValue = { [name]: { ...c.attributes } }
      c.values.forEach(v => {
        cookie.setTDCampaigns(v, cookieValue)
      })
    })
  })
}

Login.componentTranslations = {
  ...LoginTranslations,
  ...CommonTranslations
}

Login.componentDefaultProps = {
  ...Login.componentDefaultProps,
  translations: {
    ...parseTranslations(Login.componentTranslations, true)
  }
}

Login.onLoginSuccessAdditionalAction = async loginData => {
  const cartCounter = localstorage.get('reactCartCounter')
  cartCounter && updateCartCounter(cartCounter)
  loginData &&
    loginData.td_campaigns &&
    setTDCampaignsCookies(loginData.td_campaigns)
  loginData &&
    loginData.cartMigrationErrors &&
    loginData.cartMigrationErrors.length > 0 &&
    localstorage.set('CartMigrationErrors', loginData.cartMigrationErrors)
  loginData &&
    loginData.promotionNotices &&
    localstorage.set('promotionNotices', loginData.promotionNotices)
  const authToken = cookie.getToken()
  if (authToken) {
    try {
      // checkExternalCampaign
      const ecc = localstorage.get('ECC')
      localstorage.remove('ECC')
      if (ecc) {
        api.cart.externalCampaign(authToken, ecc)
      }
    } catch {} // silent failure
  }
}

export default Login
